@if (filtersChecked()) {
    <div class="flex flex-col items-center">
        @if (!waitedForDispatch()) {
            <div
                [@fadeIn]
                class="notification-drawer__content__message mat-body-1 text-cool-gray-400 bg-white text-center">
                <app-dot-loader-scale class="mx-auto"></app-dot-loader-scale>
            </div>
            
        } 
        @if (waitedForDispatch()) {
            <img 
                [@fadeIn] 
                src="assets/images/empty-state-svgs/empty-decisioning.svg" 
                alt="Empty notifications list."
                class="w-[60px] mb-8"
            >
            @if (noNotificationsMatchFilters()) {
                <div [@fadeIn]>No notification results were found.</div>
                <div [@fadeIn]>Please try adjusting your filters.</div>      
            } @else {
                <div [@fadeIn] class="text-med">It's all good - you're all caught up.</div>
            }
        }
    </div>
}
